var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 117,
    viewBox: "0 0 98 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5580_211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.3992 41.4838V34.341C83.3992 15.375 68.0243 0 49.0582 0C30.0922 0 14.7175 15.375 14.7175 34.3407V41.4836C5.69475 46.0881 0.0110381 55.358 0 65.4878V90.017C0.0163272 104.912 12.087 116.983 26.982 116.999H71.1345C86.0295 116.983 98.1004 104.912 98.1165 90.017V65.488C98.1057 55.3582 92.4219 46.0881 83.3992 41.4838ZM49.0582 14.7175C59.8958 14.7175 68.6815 23.5031 68.6815 34.3407V38.5058H29.435V34.3407C29.435 23.5031 38.2206 14.7175 49.0582 14.7175ZM83.3992 90.017C83.3992 96.7905 77.9082 102.282 71.1347 102.282H26.9822C20.2087 102.282 14.7177 96.7905 14.7177 90.017V65.488C14.7177 58.7145 20.2087 53.2235 26.9822 53.2235H71.1347C77.9082 53.2235 83.3992 58.7145 83.3992 65.488V90.017Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5580_211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 117,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentLock);
export default __webpack_public_path__ + "static/media/payment-lock.32a55bf2febeb9bd26e0822b743d6b4a.svg";
export { ForwardRef as ReactComponent };